import { useState } from "react";
import { Link } from "react-router-dom";
import { FAQ, COMMENTS } from "../../../mocks/mockContent";
import Reveal from "../../../components/feature/Reveal";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);
  return (
    <section aria-label="关于与常见问题" className="border-t hairline bg-background-50">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2">
        {/* about blurbs + comments */}
        <Reveal>
          <p className="flex items-center gap-2 text-sm font-semibold tracking-wide text-primary-700">
            <i className="ri-heart-pulse-line" aria-hidden="true"></i>
            瓜友评价
          </p>
          <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            为什么大家都来瓜田吃瓜
          </h2>
          <p className="mt-4 max-w-xl text-[15px] leading-7 text-foreground-600">
            瓜田日报不只是信息聚合站，更是一套温和的吃瓜姿势：观点正向、表达克制、尊重事实。
            我们想做的，是让每一条公共话题都值得被认真围观。
          </p>

          <ul className="mt-6 space-y-4">
            {COMMENTS.map((c) => (
              <li key={c.name} className="rounded-2xl border hairline bg-background-100/50 p-5">
                <p className="text-sm leading-6 text-foreground-700">「{c.text}」</p>
                <div className="mt-3 flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-sm text-background-50">
                    {c.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{c.name}</p>
                    <p className="text-xs text-foreground-500">{c.role}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700"
          >
            关于我们与内容原则
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </Reveal>

        {/* FAQ accordion */}
        <Reveal delay={100}>
          <div className="flex items-center justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-semibold tracking-wide text-accent-700">
                <i className="ri-question-line" aria-hidden="true"></i>
                新手答疑
              </p>
              <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">吃瓜常见问题</h2>
            </div>
          </div>

          <div className="mt-6 divide-y hairline rounded-2xl border hairline bg-background-100/40">
            {FAQ.map((f, i) => {
              const isOpen = openIdx === i;
              return (
                <div key={f.q} className="px-5">
                  <button
                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-3 py-4 text-left"
                  >
                    <span className={`font-display text-base font-semibold ${isOpen ? "text-primary-700" : "text-foreground-900"}`}>
                      {f.q}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"}`}>
                      <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="pb-4">
                      <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}